<div class="box u-mb5" [ngClass]="boxColor" *ngIf="usingAspect === 'INITIAL' && (personData | keyvalue)?.length !== 0 ">
  <div class="row">
    <div class="col-lg-4 box__user">
      <div class="row">
        <div class="col-lg-4 col-sm-3 col-12 u-center">
          <img class="user rounded-circle " [ngClass]="{
            'fixed-dimensions': imageDimensions === 'default',
            'fixed-dimensions__tiny': imageDimensions === 'tiny'
          }" [src]="sanitizedBase64Image" alt="">
        </div>
        <div class="col-lg-8 col-sm-9 col-12">
          <div class="form">
            <label for="" class="label">
              Nombre
            </label>
            <p class="txt txt--small">
              {{personData?.fullName}}&nbsp;
            </p>
          </div>
          <div class="form">
            <label for="" class="label">
              {{personData.rutDv ? 'Rut' : 'Pasaporte'}}&nbsp;
            </label>
            <p class="txt txt--small u-mb0">
              {{personData.rutDv ? (personData?.rutDv | parseRut) :  personData.passport}}&nbsp;
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-8">
      <div class="row">
        <div class="col-lg-4">
          <div class="row">
            <div class="col-lg-12 col-sm-6 col-12">
              <div class="form">
                <label for="" class="label">
                  Entidad
                </label>
                <p class="txt txt--small">
                  {{personData?.entity}}&nbsp;
                </p>
              </div>
            </div>
            <div class="col-lg-12 col-sm-6 col-12">
              <div class="form">
                <label for="" class="label">
                  Empresa
                </label>
                <p class="txt txt--small">
                  {{personData?.company}}&nbsp;
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="row">
            <div class="col-lg-12 col-sm-6 col-12">
              <div class="form">
                <label for="" class="label">
                  Gerencia
                </label>
                <p class="txt txt--small">
                  {{personData?.management}}&nbsp;
                </p>
              </div>
            </div>
            <div class="col-lg-12 col-sm-6 col-12">
              <div class="form">
                <label for="" class="label">
                  Unidad de negocio
                </label>
                <p class="txt txt--small">
                  {{personData?.businessUnit}}&nbsp;
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="row">
            <div class="col-lg-12 col-sm-6 col-12">
              <div class="form">
                <label for="" class="label">
                  Sistema turno
                </label>
                <p class="txt txt--small">
                  {{personData?.shiftWork}}&nbsp;
                </p>
              </div>
            </div>
            <div class="col-lg-12 col-sm-6 col-12">
              <div class="form">
                <label for="" class="label">
                  Correo electrónico
                </label>
                <p class="txt txt--small">
                  {{personData?.email}}&nbsp;
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- para loader de card  -->
<div class="box u-mb5" [ngClass]="boxColor" *ngIf="usingAspect === 'INITIAL' && (personData | keyvalue)?.length === 0 ">
  <div class="row">
    <div class="col-lg-4 box__user">
      <div class="row">
        <div class="col-lg-4 col-3 u-center">
          <div class="blank-photo"> </div>
        </div>
        <div class="col-lg-8 col-9">
          <div class="form">
            <label class="label row-blank-title">
            </label>
            <p class="txt txt--small row-blank">
            </p>
          </div>
          <div class="form">
            <label class="label row-blank-title">
            </label>
            <p class="txt txt--small row-blank">
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-8">
      <div class="row">
        <div class="col-lg-4">
          <div class="row">
            <div class="col-lg-12 col-sm-6 col-12">
              <div class="form">
                <label class="label row-blank-title">
                </label>
                <p class="txt txt--small row-blank">
                </p>
              </div>
            </div>
            <div class="col-lg-12 col-sm-6 col-12">
              <div class="form">
                <label class="label row-blank-title">
                </label>
                <p class="txt txt--small row-blank">
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="row">
            <div class="col-lg-12 col-sm-6 col-12">
              <div class="form">
                <label class="label row-blank-title">
                </label>
                <p class="txt txt--small row-blank">
                </p>
              </div>
            </div>
            <div class="col-lg-12 col-sm-6 col-12">
              <div class="form">
                <label class="label row-blank-title">
                </label>
                <p class="txt txt--small row-blank">
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="row">
            <div class="col-lg-12 col-sm-6 col-12">
              <div class="form">
                <label class="label row-blank-title">
                </label>
                <p class="txt txt--small row-blank">
                </p>
              </div>
            </div>
            <div class="col-lg-12 col-sm-6 col-12">
              <div class="form">
                <label class="label row-blank-title">
                </label>
                <p class="txt txt--small row-blank">
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="col-md-12 containerDetail"
  *ngIf="usingAspect === 'MY_PROFILE' && (completeUserData | keyvalue)?.length !== 0">
  <div class="u-mb70">
    <div class="row containerDetailDriverMyProfile">
      <div class="col-lg-2 u-center containerPhoto">
        <img class="user rounded-circle " [ngClass]="{
          'fixed-dimensions': imageDimensions === 'default',
          'fixed-dimensions__tiny': imageDimensions === 'tiny'
        }" [src]="sanitizedBase64Image" alt="">
      </div>
      <div class="col-lg-10">
        <div class="row">
          <div class="col-md-3 expansionCellsCarPerson">
            <div class="form containerForm">
              <label for="" class="label">
                Nombre
              </label>
              <p class="txt txt--small">
                {{completeUserData?.fullName}}&nbsp;
              </p>
            </div>
          </div>
          <div class="col-md-2 expansionCellsCarPerson">
            <div class="form containerForm">
              <label for="" class="label">
                Fecha de nacimiento
              </label>
              <p class="txt txt--small">
                {{ (birthDate || completeUserData?.birthDate) | date: 'dd/MM/YYYY' }}&nbsp;
              </p>
            </div>
          </div>
          <div class="col-md-2 expansionCellsCarPerson">
            <div class="form containerForm">
              <label for="" class="label">
                Género
              </label>
              <p class="txt txt--small">
                {{completeUserData?.gender}}&nbsp;
              </p>
            </div>
          </div>
          <div class="col-md-2 expansionCellsCarPerson">
            <div class="form containerForm">
              <label for="" class="label">
                {{completeUserData.rutDv ? 'Rut' : 'Pasaporte'}}&nbsp;
              </label>
              <p class="txt txt--small">
                {{completeUserData.rutDv ? (completeUserData?.rutDv | parseRut) :  completeUserData.passport}}&nbsp;
              </p>
            </div>
          </div>
          <div class="col-md-3 expansionCellsCarPerson">
            <div class="form containerForm">
              <label for="" class="label">
                Dirección
              </label>
              <p class="txt txt--small">
                {{completeUserData?.address}}&nbsp;
              </p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3 expansionCellsCarPerson">
            <div class="form containerForm">
              <label for="" class="label">
                Correo electrónico
              </label>
              <p class="txt txt--small textOverflow">
                {{completeUserData?.email}}&nbsp;
              </p>
            </div>
          </div>
          <div class="col-md-2 expansionCellsCarPerson">
            <div class="form containerForm">
              <label for="" class="label">
                Teléfono
              </label>
              <p class="txt txt--small">
                {{completeUserData?.cellPhoneNumber}}&nbsp;
              </p>
            </div>
          </div>
          <div class="col-md-2 expansionCellsCarPerson">
            <div class="form containerForm">
              <label for="" class="label">
                Contacto de emergencia
              </label>
              <p class="txt txt--small">
                {{completeUserData?.emergencyContactName}}&nbsp;
              </p>
            </div>
          </div>
          <div class="col-md-2 expansionCellsCarPerson">
            <div class="form containerForm">
              <label for="" class="label">
                Teléfono de emergencia
              </label>
              <p class="txt txt--small">
                {{completeUserData?.emergencyContactNumber}}&nbsp;
              </p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="u-mt5 u-mb20 u-bt u-bt--grey"></div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3 expansionCellsCarPerson2">
            <div class="form containerForm">
              <label for="" class="label">
                Cargo
              </label>
              <p class="txt txt--small">
                {{completeUserData.userProfesionalData?.position}}&nbsp;
              </p>
            </div>
          </div>
          <div class="col-md-2 expansionCellsCarPerson2">
            <div class="form containerForm">
              <label for="" class="label">
                Gerencia
              </label>
              <p class="txt txt--small">
                {{completeUserData.userProfesionalData?.management}}&nbsp;
              </p>
            </div>
          </div>
          <div class="col-md-2 expansionCellsCarPerson2">
            <div class="form containerForm">
              <label for="" class="label">
                Sistema turno
              </label>
              <p class="txt txt--small">
                {{completeUserData.userProfesionalData?.shiftSystem}}&nbsp;
              </p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3 expansionCellsCarPerson2">
            <div class="form containerForm">
              <label for="" class="label">
                Empresa
              </label>
              <p class="txt txt--small">
                {{completeUserData.userProfesionalData?.business}}&nbsp;
              </p>
            </div>
          </div>
          <div class="col-md-2 expansionCellsCarPerson2">
            <div class="form containerForm">
              <label for="" class="label">
                Unidad de negocio
              </label>
              <p class="txt txt--small">
                {{completeUserData.userProfesionalData?.businessUnit}}&nbsp;
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="col-md-12 containerDetail"
  *ngIf="usingAspect === 'MY_PROFILE' && (completeUserData | keyvalue)?.length === 0 ">
  <div class="u-mb70">
    <div class="row containerDetailDriverMyProfile">
      <div class="col-lg-2 u-center containerPhoto ">
        <div class="blank-photo"> </div>
      </div>
      <div class="col-lg-10">
        <div class="row">
          <div class="col-md-3 expansionCellsCarPerson">
            <div class="form containerForm">
              <label class="label row-blank-title">
              </label>
              <p class="txt txt--small row-blank">
              </p>
            </div>
          </div>
          <div class="col-md-2 expansionCellsCarPerson">
            <div class="form containerForm">
              <label class="label row-blank-title">
              </label>
              <p class="txt txt--small row-blank">
              </p>
            </div>
          </div>
          <div class="col-md-2 expansionCellsCarPerson">
            <div class="form containerForm">
              <label class="label row-blank-title">
              </label>
              <p class="txt txt--small row-blank">
              </p>
            </div>
          </div>
          <div class="col-md-2 expansionCellsCarPerson">
            <div class="form containerForm">
              <label class="label row-blank-title">
              </label>
              <p class="txt txt--small row-blank">
              </p>
            </div>
          </div>
          <div class="col-md-3 expansionCellsCarPerson">
            <div class="form containerForm">
              <label class="label row-blank-title">
              </label>
              <p class="txt txt--small row-blank">
              </p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3 expansionCellsCarPerson">
            <div class="form containerForm">
              <label class="label row-blank-title">
              </label>
              <p class="txt txt--small row-blank">
              </p>
            </div>
          </div>
          <div class="col-md-2 expansionCellsCarPerson">
            <div class="form containerForm">
              <label class="label row-blank-title">
              </label>
              <p class="txt txt--small row-blank">
              </p>
            </div>
          </div>
          <div class="col-md-2 expansionCellsCarPerson">
            <div class="form containerForm">
              <label class="label row-blank-title">
              </label>
              <p class="txt txt--small row-blank">
              </p>
            </div>
          </div>
          <div class="col-md-2 expansionCellsCarPerson">
            <div class="form containerForm">
              <label class="label row-blank-title">
              </label>
              <p class="txt txt--small row-blank">
              </p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="u-mt5 u-mb20 u-bt u-bt--grey"></div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3 expansionCellsCarPerson2">
            <div class="form containerForm">
              <label class="label row-blank-title">
              </label>
              <p class="txt txt--small row-blank">
              </p>
            </div>
          </div>
          <div class="col-md-2 expansionCellsCarPerson2">
            <div class="form containerForm">
              <label class="label row-blank-title">
              </label>
              <p class="txt txt--small row-blank">
              </p>
            </div>
          </div>
          <div class="col-md-2 expansionCellsCarPerson2">
            <div class="form containerForm">
              <label class="label row-blank-title">
              </label>
              <p class="txt txt--small row-blank">
              </p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3 expansionCellsCarPerson2">
            <div class="form containerForm">
              <label for="" class="label row-blank-title">
              </label>
              <p class="txt txt--small row-blank">
              </p>
            </div>
          </div>
          <div class="col-md-2 expansionCellsCarPerson2">
            <div class="form containerForm">
              <label class="label row-blank-title">
              </label>
              <p class="txt txt--small row-blank">
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="box " [ngClass]="boxColor"
  *ngIf="usingAspect === 'INFRACTIONS' && (personData | keyvalue)?.length !== 0 && lastInfractionsData">
  <div class="row">
    <div class="col-lg-3 box__user">
      <div class="row">
        <div class="col-lg-4 col-3 u-center">
          <img class="user rounded-circle fixed-dimensions__tiny" [src]="sanitizedBase64Image" alt="">
        </div>
        <div class="col-lg-8 col-9">
          <div class="form">
            <label for="" class="label">
              Nombre
            </label>
            <p class="txt txt--small">
              {{personData?.fullName}}&nbsp;
            </p>
          </div>
          <div class="form">
            <label for="" class="label">
              {{personData.rutDv ? 'Rut' : 'Pasaporte'}}&nbsp;
            </label>
            <p class="txt txt--small u-mb0">
              {{personData.rutDv ? (personData?.rutDv | parseRut) :  personData.passport}}&nbsp;
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-9">
      <div class="row">
        <div class="col-lg-2">
          <div class="row">
            <div class="col-lg-12 col-sm-6 col-12">
              <div class="form">
                <label for="" class="label">
                  Entidad
                </label>
                <p class="txt txt--small">
                  {{personData?.entity}}&nbsp;
                </p>
              </div>
            </div>
            <div class="col-lg-12 col-sm-6 col-12">
              <div class="form">
                <label for="" class="label">
                  Empresa
                </label>
                <p class="txt txt--small">
                  {{personData.company}}&nbsp;
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="row">
            <div class="col-lg-12 col-sm-6 col-12">
              <div class="form">
                <label for="" class="label">
                  Gerencia
                </label>
                <p class="txt txt--small">
                  {{personData?.management}}&nbsp;
                </p>
              </div>
            </div>
            <div class="col-lg-12 col-sm-6 col-12">
              <div class="form">
                <label for="" class="label">
                  Unidad de negocio
                </label>
                <p class="txt txt--small">
                  {{personData?.businessUnit}}&nbsp;
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="row">
            <div class="col-lg-12 col-sm-6 col-12">
              <div class="form">
                <label for="" class="label">
                  Sistema turno
                </label>
                <p class="txt txt--small">
                  {{personData?.shiftWork}}&nbsp;
                </p>
              </div>
            </div>
            <div class="col-lg-12 col-sm-6 col-12">
              <div class="form">
                <label for="" class="label">
                  Correo electrónico
                </label>
                <p class="txt txt--small textOverflow">
                  {{personData?.email}}&nbsp;
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4 box__last">
          <div class="form">
            <label for="" class="label">
              Últimas infracciones:
            </label>
            <p class="txt txt--small">
              <ng-container *ngFor="let item of lastInfractionsData">
                {{  item.dateRegister | dateFromBack }} - Infracción {{item.infringmentSeverity}} Nº {{item.id}}&nbsp;
              </ng-container>
              <ng-container *ngIf="lastInfractionsData.length === 0">
                No tiene infracciones registradas
              </ng-container>
            </p>
            <p class="txt txt--small">
              <a  [routerLink]="infractionsLinkPath" >
                Ver historial y detalle de infracciones
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="box" [ngClass]="boxColor"
  *ngIf="usingAspect === 'INFRACTIONS' && !((personData | keyvalue)?.length !== 0 && lastInfractionsData)">
  <div class="row">
    <div class="col-lg-4 box__user">
      <div class="row">
        <div class="col-lg-4 col-3 u-center">
          <div class="blank-photo"> </div>
        </div>
        <div class="col-lg-8 col-9">
          <div class="form">
            <label class="label row-blank-title">
            </label>
            <p class="txt txt--small row-blank">
            </p>
          </div>
          <div class="form">
            <label class="label row-blank-title">
            </label>
            <p class="txt txt--small row-blank">
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-8">
      <div class="row">
        <div class="col-lg-4">
          <div class="row">
            <div class="col-lg-12 col-sm-6 col-12">
              <div class="form">
                <label class="label row-blank-title">
                </label>
                <p class="txt txt--small row-blank">
                </p>
              </div>
            </div>
            <div class="col-lg-12 col-sm-6 col-12">
              <div class="form">
                <label class="label row-blank-title">
                </label>
                <p class="txt txt--small row-blank">
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="row">
            <div class="col-lg-12 col-sm-6 col-12">
              <div class="form">
                <label class="label row-blank-title">
                </label>
                <p class="txt txt--small row-blank">
                </p>
              </div>
            </div>
            <div class="col-lg-12 col-sm-6 col-12">
              <div class="form">
                <label class="label row-blank-title">
                </label>
                <p class="txt txt--small row-blank">
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="row">
            <div class="col-lg-12 col-sm-6 col-12">
              <div class="form">
                <label class="label row-blank-title">
                </label>
                <p class="txt txt--small row-blank">
                </p>
              </div>
            </div>
            <div class="col-lg-12 col-sm-6 col-12">
              <div class="form">
                <label class="label row-blank-title">
                </label>
                <p class="txt txt--small row-blank">
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
